import React from 'react';
import Lightbox from 'yet-another-react-lightbox';
import Captions from 'yet-another-react-lightbox/dist/plugins/captions';
import Fullscreen from 'yet-another-react-lightbox/dist/plugins/fullscreen';
import Counter from 'yet-another-react-lightbox/dist/plugins/counter';
import Thumbnails from 'yet-another-react-lightbox/dist/plugins/thumbnails';
import Video from 'yet-another-react-lightbox/dist/plugins/video';
import Zoom from 'yet-another-react-lightbox/dist/plugins/zoom';
import 'yet-another-react-lightbox/dist/styles.css';
import 'yet-another-react-lightbox/dist/plugins/thumbnails/thumbnails.css';
import 'yet-another-react-lightbox/dist/plugins/counter/counter.css';
import { Typography, Stack, colors, Hidden, FormControl, InputLabel, Select, MenuItem, Fab, Box, Tooltip, Button, Popover } from '@mui/material';
import IframeResizer from 'iframe-resizer-react';
import MenuDrawer from '../../components/MenuDrawer';
import AddIcon from '@mui/icons-material/Add';
import AdminIcon from '@mui/icons-material/Person';
import MaximizeIcon from '@mui/icons-material/OpenInFull';
import MinimizeIcon from '@mui/icons-material/CloseFullscreen';
import InfoIcon from '@mui/icons-material/QuestionMark';
import HeaderSDG from '../../components/HeaderSDG';
import dictionaries from '../../helpers/dictionary';
import { isFunctionEligible } from '../../helpers/eligibilityChecker';
const headerBackground = { background: `linear-gradient(123deg, rgba(0,194,109,1) 0%, rgba(66,165,245,1) 40%, rgba(187,222,251,1) 100%);` };

const Dashboard = ({ userInfo }) => {
  const [iframeSRC, setIframeSRC] = React.useState('');
  const [anchor, setAnchor] = React.useState(null);
  const [lang, setLang] = React.useState('en');
  const popupRef = React.useRef(null);
  const [rstatus, setRstatus] = React.useState('all'); // rank1, big2, big3, big4, big5
  const [showTutorial, setShowTutorial] = React.useState(false);

  const init = () => {
    const src = '?lang=en';
    setIframeSRC(src);
  };

  const keshifURL = process.env.REACT_APP_STAGE === 'DEVELOPMENT' ? process.env.REACT_APP_KESHIF_DEV : process.env.REACT_APP_KESHIF_PROD;
  const APP_URL = process.env.REACT_APP_STAGE === 'DEVELOPMENT' ? process.env.REACT_APP_HOST : process.env.REACT_APP_HOST_PROD;

  React.useEffect(() => {
    init();
    if (popupRef.current) {
      setTimeout(() => {
        popupRef?.current?.click();
      }, 3000);
    }
  }, []);
  return (
    <Stack direction='column' justifyContent='space-between' sx={{ height: '100vh' }}>
      <Lightbox
        styles={{
          container: { backgroundColor: 'rgba(0, 0, 0, .7)' },
        }}
        open={showTutorial}
        close={() => setShowTutorial(false)}
        plugins={[Fullscreen, Counter]}
        thumbnails={{
          imagefit: 'contain',
          position: 'bottom',
          width: 50,
          height: 50,
          border: 1,
          borderRadius: 4,
          padding: 4,
          gap: 4,
          showToggle: false,
        }}
        slides={[
          // { src: '/repository/assets/tutorial/1.jpg', width: 1200 },
          // { src: '/repository/assets/tutorial/2.jpg', width: 1200 },
          // { src: '/repository/assets/tutorial/3.jpg', width: 1200 },
          { src: '/assets/tutorial/4.jpg', width: 1200 },
          { src: '/assets/tutorial/4.jpg', width: 1200 },
          { src: '/assets/tutorial/5.jpg', width: 1200 },
          { src: '/assets/tutorial/6.jpg', width: 1200 },
          { src: '/assets/tutorial/7.jpg', width: 1200 },
          { src: '/assets/tutorial/8.jpg', width: 1200 },
          { src: '/assets/tutorial/9.jpg', width: 1200 },
          { src: '/assets/tutorial/10.jpg', width: 1200 },
          { src: '/assets/tutorial/11.jpg', width: 1200 },
        ]}
      />
      <HeaderSDG />
      <iframe
        src={
          process.env.REACT_APP_STAGE === 'DEVELOPMENT'
            ? `http://localhost:3004/prod/?id=sdgs&lang=${lang}&rstatus=${rstatus}&env=${process.env.REACT_APP_STAGE.toLowerCase()}`
            : `https://domes.un.or.id/keshif/prod/?id=sdgs&lang=${lang}&rstatus=${rstatus}&env=${process.env.REACT_APP_STAGE.toLowerCase()}`
        }
        style={{ minWidth: '100vw', height: 100000, border: 0 }}
      />
      <Stack sx={{ height: 30, backgroundColor: colors.blueGrey[600] }} direction='row' justifyContent='center' alignItems='center' spacing={2}>
        <Stack>
          <Typography variant='caption' sx={{ color: '#FFFFFF', textAlign: 'center', fontWeight: 700 }}>
            &copy; UN in Indonesia
          </Typography>
        </Stack>
        <Stack>
          <Typography sx={{ color: '#FFFFFF' }}>|</Typography>
        </Stack>
        <Stack m={1} direction='row' alignItems='center' spacing={1}>
          <Typography variant='caption' sx={{ color: '#FFFFFF', fontWeight: 600 }}>
            Language:
          </Typography>
          <Select
            variant='standard'
            sx={{ color: '#FFFFFF', fontSize: 12, fontWeight: 600 }}
            labelId='language-select'
            id='language-select'
            value={lang}
            label='Language'
            onChange={(e) => setLang(e.target.value)}
          >
            <MenuItem value='en'>English</MenuItem>
            <MenuItem value='id'>Indonesian</MenuItem>
          </Select>
        </Stack>
        {/* <Stack>
          <Typography sx={{ color: '#FFFFFF' }}>|</Typography>
        </Stack> */}
        {/* <Stack m={1} sx={{ width: 200 }} direction='row' alignItems='center' spacing={1}>
          <Typography variant='caption' sx={{ color: '#FFFFFF', fontWeight: 600 }}>
            SDG Award Rankings:
          </Typography>
          <Select
            variant='standard'
            sx={{ color: '#FFFFFF', fontSize: 12, fontWeight: 600 }}
            labelId='rank-select'
            id='rank-select'
            value={rstatus}
            label='SDG Award Rankings'
            onChange={(e) => setRstatus(e.target.value)}
          >
            <MenuItem value='big_1'>Rank 1</MenuItem>
            <MenuItem value='big_2'>Big 2</MenuItem>
            <MenuItem value='big_3'>Big 3</MenuItem>
            <MenuItem value='big_4'>Big 4</MenuItem>
            <MenuItem value='big_5'>Big 5</MenuItem>
            <MenuItem value='all'>All</MenuItem>
          </Select>
        </Stack> */}
      </Stack>
      <Hidden mdUp>
        <Box sx={{ alignItems: 'center', position: 'absolute', right: 10, top: 90 }}>
          {isFunctionEligible(userInfo.type, 'fab_portal') && (
            <Box sx={{ m: 1, position: 'relative' }}>
              <Tooltip title='Portal'>
                <Fab
                  aria-label='portal'
                  sx={{ backgroundColor: colors.blue[500], color: 'white', width: 40, height: 40 }}
                  onClick={() => window.open(`${APP_URL}/portal`, '_blank')}
                >
                  <AdminIcon color='white' fontSize='large' />
                </Fab>
              </Tooltip>
            </Box>
          )}
        </Box>
        <Box sx={{ alignItems: 'center', position: 'absolute', right: 10, top: 40 }}>
          <Box sx={{ m: 1, position: 'relative' }}>
            <Tooltip title='Create new questionnaire'>
              <Fab sx={{ width: 40, height: 40 }} aria-label='open-questionnaire' color='primary' onClick={() => window.open(`${APP_URL}/form`, '_blank')}>
                <AddIcon color='white' fontSize='medium' />
              </Fab>
            </Tooltip>
          </Box>
        </Box>
        <Box sx={{ alignItems: 'center', position: 'absolute', right: 65, top: 40 }}>
          <Box sx={{ m: 1, position: 'relative' }}>
            <Tooltip title={dictionaries?.how_to_use[lang]}>
              <Fab
                aria-label='open-information'
                sx={{ backgroundColor: colors.amber[500], color: 'white', width: 40, height: 40 }}
                onClick={() => window.open(`${APP_URL}/information`, '_blank')}
              >
                <InfoIcon color='white' fontSize='medium' />
              </Fab>
            </Tooltip>
          </Box>
        </Box>
      </Hidden>
      <Hidden mdDown>
        <Box sx={{ alignItems: 'center', position: 'absolute', right: 10, top: 80 }}>
          {isFunctionEligible(userInfo.type, 'fab_portal') && (
            <Box sx={{ m: 1, position: 'relative' }}>
              <Tooltip title='Portal'>
                <Fab aria-label='portal' sx={{ backgroundColor: colors.blue[500], color: 'white' }} onClick={() => window.open(`${APP_URL}/portal`, '_blank')}>
                  <AdminIcon color='white' fontSize='large' />
                </Fab>
              </Tooltip>
            </Box>
          )}
        </Box>
        <Box sx={{ alignItems: 'center', position: 'absolute', right: 10, top: 10 }}>
          <Box sx={{ m: 1, position: 'relative' }}>
            <Tooltip title='Create new questionnaire'>
              <Fab aria-label='open-questionnaire' color='primary' onClick={() => window.open(`${APP_URL}/form`, '_blank')}>
                <AddIcon color='white' fontSize='large' />
              </Fab>
            </Tooltip>
          </Box>
        </Box>
        <Box sx={{ alignItems: 'center', position: 'absolute', right: 75, top: 10 }}>
          <Box sx={{ m: 1, position: 'relative' }}>
            <Tooltip title={dictionaries?.how_to_use[lang]}>
              <Fab
                aria-label='open-information'
                sx={{ backgroundColor: colors.amber[500], color: 'white' }}
                onClick={() => window.open(`${APP_URL}/information`, '_blank')}
              >
                <InfoIcon color='white' fontSize='large' />
              </Fab>
            </Tooltip>
          </Box>
        </Box>
      </Hidden>
      <div>
        <Stack
          ref={popupRef}
          onClick={(e) => setAnchor(e.currentTarget)}
          sx={{ backgroundColor: colors.blue[400], position: 'absolute', bottom: 30, right: 10, padding: 1 }}
        >
          <MaximizeIcon sx={{ color: 'white' }} />
        </Stack>

        <Popover
          id='Popup'
          open={Boolean(anchor)}
          anchorEl={anchor}
          onClose={() => setAnchor(null)}
          anchorOrigin={{
            vertical: 'left',
            horizontal: 'left',
          }}
        >
          <Stack direction='column' sx={{ backgroundColor: colors.blue[400], height: 'auto', width: 400 }}>
            <Stack sx={{ alignSelf: 'flex-end', padding: 1, paddingRight: 2 }} onClick={() => setAnchor(null)}>
              <MinimizeIcon sx={{ color: 'white' }} />
            </Stack>
            <Stack direction='column' sx={{ height: '100%', margin: 1, backgroundColor: 'white', padding: 2 }}>
              <Typography variant='h4' sx={{ textAlign: 'center', color: colors.blue[700] }}>
                {dictionaries?.how_to_use[lang]}
              </Typography>
              <Typography variant='body1' sx={{ textAlign: 'center', fontWeight: 'bold' }}>
                {dictionaries?.welcome[lang]}
              </Typography>
              <Typography variant='body2' sx={{ textAlign: 'center' }}>
                {dictionaries?.landing_tooltip[lang]}
              </Typography>
              <Box sx={{ alignSelf: 'center', padding: 4 }}>
                {/* <Button onClick={() => window.open(`${APP_URL}/information`, '_blank')} variant='contained' sx={{ backgroundColor: colors.amber[700] }}>
                  LEARN HOW
                </Button> */}
                <Button onClick={() => setShowTutorial(true)} variant='contained' sx={{ backgroundColor: colors.blue[700] }}>
                  LEARN HOW
                </Button>
              </Box>
              {/* <Typography variant='caption' sx={{ textDecoration: 'underline', alignSelf: 'flex-end' }}>
                Don't show this again
              </Typography> */}
            </Stack>
          </Stack>
        </Popover>
      </div>
    </Stack>
  );
};

export default Dashboard;
